// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/icomoon/style.css
// module id = 1675
// module chunks = 0